import {
  defineComponent,
} from 'vue';

export default defineComponent({
  delimiters: ['${', '}'],
  props: {
    isSos: {
      type: Boolean,
      default: false,
    },
    sku: {
      type: String,
      default: null,
    },
    salePrice: {
      type: String,
      default: null,
    },
    uri: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
    loginUrl: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    let loginUrlWithUri;
    if (props.uri) {
      const theUrl = new URL(props.loginUrl);
      theUrl.searchParams.set('returnUri', props.uri);
      loginUrlWithUri = theUrl.toString();
    }
    return {
      loginUrlWithUri: props.uri ? loginUrlWithUri : props.loginUrl,
    }
  },
  computed: {
    isCustomer() {
      return this.$store.getters.statuses.isCustomer;
    },
    isStopped() {
      return this.$store.getters.statuses.isStopped;
    },
  },
  template: '#t-product-card-price',
});
